import React from "react";
import hoistNonReactStatics from "hoist-non-react-statics";
import { gql } from "@apollo/client";

import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
} from "@mui/material";
import {
  Cancel as NoImageIcon,
  CartOff as NotInShopIcon,
  EyeOff as UnpublishedIcon,
} from "mdi-material-ui";

import MouthpieceLabel from "components/mouthpiece/MouthpieceLabel";

function SignatureMouthpiecesListItem(
  { signatureMouthpiece, disableDrag, handleProps, children, ...props },
  ref
) {
  return (
    <ListItem ref={ref} dense divider {...props}>
      {children}

      <ListItemAvatar>
        <Avatar src={signatureMouthpiece.artistImage?.url}>
          {!signatureMouthpiece.artistImage?.url && <NoImageIcon />}
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        primary={signatureMouthpiece.signature}
        secondary={
          <MouthpieceLabel mouthpieceRef={signatureMouthpiece.mouthpieceRef} />
        }
      />

      <ListItemSecondaryAction>
        {!signatureMouthpiece.inShop && (
          <Tooltip placement="top" title="Non visible dans la boutique">
            <NotInShopIcon color="disabled" />
          </Tooltip>
        )}

        {!signatureMouthpiece.published && (
          <Tooltip placement="top" title="Non publié">
            <UnpublishedIcon color="disabled" />
          </Tooltip>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
}

SignatureMouthpiecesListItem.fragments = {
  signatureMouthpiece: gql`
    fragment SignatureMouthpiecesListItem_signatureMouthpiece on SignatureMouthpiece {
      id
      published
      inShop
      signature

      artistImage {
        id
        url
      }

      mouthpieceRef {
        id
        ...MouthpieceLabel_mouthpieceRef
      }
    }

    ${MouthpieceLabel.fragments.mouthpieceRef}
  `,
};

export default hoistNonReactStatics(
  React.forwardRef(SignatureMouthpiecesListItem),
  SignatureMouthpiecesListItem
);
